module.exports = __webpack_public_path__ + "img/hot_eles_banner1.dfedce7f.png";